// extracted by mini-css-extract-plugin
export default {"container":"MaskItemsControls_container__sQkL7","label":"MaskItemsControls_label__Vqa8n","switch":"MaskItemsControls_switch__NvPCm","divider":"MaskItemsControls_divider__8J572"};